import { render, staticRenderFns } from "./GroupMemberDetails.vue?vue&type=template&id=7400e43c&scoped=true&"
import script from "./GroupMemberDetails.vue?vue&type=script&lang=js&"
export * from "./GroupMemberDetails.vue?vue&type=script&lang=js&"
import style0 from "./GroupMemberDetails.vue?vue&type=style&index=0&id=7400e43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7400e43c",
  null
  
)

export default component.exports